module.exports = __webpack_public_path__ + "img/banner03_img.76bb61a9.png";